module.exports = __webpack_public_path__ + "static/media/logo_bordas_transp.5537fe1b.png";